import { Caption1, Text, makeStyles } from '@fluentui/react-components';
import { getStepType, fileCategoryLabels } from '@vigeo/shared';
import { tokens } from '@vigeo/ui';
import type { StepPortalProps, StepReviewProps, StepUiModule } from '../contract.js';
import { PdfFormPortal } from '../pdf-form/PdfFormPortal.js';

const useStyles = makeStyles({
  block: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXS },
});

const kernel = getStepType('pdf-form');

function Portal(props: StepPortalProps) {
  // The template arrives with the packet once the loader lands; until then the component
  // renders its "not available yet" state rather than a broken canvas.
  return <PdfFormPortal {...props} />;
}

function Review({ config, submission }: StepReviewProps) {
  const styles = useStyles();
  const settings = kernel.configSchema.safeParse(config);
  const answer = kernel.submissionSchema.safeParse(submission);

  return (
    <div className={styles.block}>
      <Text weight="semibold">{settings.success ? settings.data.heading : 'Official form'}</Text>
      {answer.success ? (
        <>
          <Text>{answer.data.fileName}</Text>
          {/* The flattened PDF is the evidence; the values are shown so a reviewer can see
              what was entered without opening it. */}
          <Caption1>{Object.keys(answer.data.values).length} field(s) completed</Caption1>
        </>
      ) : (
        <Text>Nothing submitted yet.</Text>
      )}
      {settings.success ? (
        <Caption1>
          Template {settings.data.templateId} v{settings.data.templateVersion} · files to{' '}
          {fileCategoryLabels[settings.data.target]}
        </Caption1>
      ) : null}
    </div>
  );
}

export const pdfFormUi: StepUiModule = { portal: Portal, review: Review };
